import React from 'react';
import { Preloader } from 'components/ui';

import css from '../styles.scss';

const LoadingIndicator = () => <Preloader size="1x" className={css.selectLoader} />;

export default LoadingIndicator;
